var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lang-switcher",class:{
    'cblack': _vm.isBlack,
    'gucci-app': _vm.$root.isApp,
    'screenshot': _vm.$root.isScreenshot,
    'homepage': _vm.$route.name === 'Home'
  }},[_c('h4',{staticClass:"current-lang regular uppercase"},[_vm._v(_vm._s(_vm.$route.params.language))]),_vm._v(" "),_c('arrowDown',{staticClass:"arrow"}),_vm._v(" "),_c('div',{staticClass:"other-lang"},_vm._l((_vm.availableLanguages),function(lang){return _c('h4',{key:lang,staticClass:"regular uppercase",on:{"click":function($event){return _vm.switchCurrentLang(lang)}}},[_vm._v("\n      "+_vm._s(lang)+"\n    ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }